import { useTranslation } from "react-i18next";
import { Button } from "@tellescope/ui";
import type { AnswerForType } from "@tellescope/types-models";

export interface BridgeEligibilityStaffPanelProps {
  eligibilityType: "Soft" | "Hard";
  serviceTypeIds: string[];
  state?: string;
  payerId?: string;
  memberId?: string;
  isChecking: boolean;
  isPolling: boolean;
  errorMessage?: string;
  value: AnswerForType["Bridge Eligibility"];
  onCheckProvider: () => void;
  onCheckService: () => void;
}

export const BridgeEligibilityStaffPanel = ({
  eligibilityType,
  serviceTypeIds,
  state,
  payerId,
  memberId,
  isChecking,
  isPolling,
  errorMessage,
  value,
  onCheckProvider,
  onCheckService,
}: BridgeEligibilityStaffPanelProps) => {
  const { t } = useTranslation("forms");
  const isConfigured = serviceTypeIds.length > 0;

  return (
    <div className="border rounded-md p-4 flex flex-col gap-3">
      <div className="flex flex-col gap-1 text-xs text-muted-foreground">
        <p>{t("Eligibility Type: {{eligibilityType}}", { eligibilityType })}</p>
        <p>
          {t("Service Type IDs: {{serviceTypeIds}}", {
            serviceTypeIds: isConfigured ? serviceTypeIds.join(", ") : t("Not configured"),
          })}
        </p>
        {!!state && <p>{t("State: {{state}}", { state })}</p>}
        {!!payerId && <p>{t("Payer ID: {{payerId}}", { payerId })}</p>}
        {!!memberId && <p>{t("Member ID: {{memberId}}", { memberId })}</p>}
      </div>

      <div className="flex gap-2 flex-wrap">
        <Button variant="outline" size="sm" disabled={!isConfigured || isChecking} onClick={onCheckProvider}>
          {t("Check Provider Eligibility (Free)")}
        </Button>
        <Button variant="outline" size="sm" disabled={!isConfigured || isChecking} onClick={onCheckService}>
          {t("Check Service Eligibility (Paid)")}
        </Button>
      </div>

      {!!isPolling && <p className="text-xs text-muted-foreground">{t("Verifying eligibility with insurance...")}</p>}
      {!!errorMessage && <p className="text-sm text-destructive">{errorMessage}</p>}

      {!!value && <pre className="text-xs bg-muted rounded p-2 overflow-x-auto">{JSON.stringify(value, null, 2)}</pre>}
    </div>
  );
};
